<template>
  <div id="gallery" class="gallery-wrap pb-75">
    <div class="container">
      <div class="row">
        <div class="col-xl-8 offset-xl-2 col-lg-10 offset-lg-1">
          <div class="section-title style1 text-center mb-40">
            <span>Gallery Exhibition</span>
            <h2>
              Discover Your Dental Repair &amp; Recovery Works For Our Medical
              Clinic
            </h2>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div
          class="col-lg-4 col-md-6"
          v-for="gallery in galleries"
          :key="gallery.id"
        >
          <div class="gallery-card style2">
            <div class="gallery-img">
              <img :src="gallery.image" alt="Image" />

              <div class="gallery-info">
                <router-link class="gallery-icon" to="/gallery-details">
                  <i class="ri-add-line"></i>
                </router-link>
                <h3>
                  <router-link to="/gallery-details">
                    Best Treatment For Healthy Life
                  </router-link>
                </h3>
                <span>Cardiology</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "GalleryExhibition",
  data: () => ({
    galleries: [
      {
        id: 1,
        image: require("../../assets/images/gallery/gallery-6.jpg"),
        title: "Best Treatment For Healthy Life",
        tag: "Cardiology",
      },
      {
        id: 2,
        image: require("../../assets/images/gallery/gallery-7.jpg"),
        title: "Special Child Care For Working Woment",
        tag: "Child Care",
      },
      {
        id: 3,
        image: require("../../assets/images/gallery/gallery-8.jpg"),
        title: "Best Maternity Care",
        tag: "Maternity",
      },
      {
        id: 4,
        image: require("../../assets/images/gallery/gallery-9.jpg"),
        title: "Cardio Checkup For Adult",
        tag: "Cardiology",
      },
      {
        id: 5,
        image: require("../../assets/images/gallery/gallery-10.jpg"),
        title: "Best Physical Therapy For Child",
        tag: "Child Care",
      },
      {
        id: 6,
        image: require("../../assets/images/gallery/gallery-11.jpg"),
        title: "Clinical Surgery For Adult",
        tag: "Neurology",
      },
    ],
  }),
});
</script>